import {useQuery} from "@tanstack/react-query";
import {
    readExchangeType3SelectBoxApi,
} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 환율 지정 조건 3 select hook
 * @param props
 * @returns
 */
export const useReadExchangeType3SelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readExchangeType3SelectBox"],
        queryFn: async () => await readExchangeType3SelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
